import api from '../api-methods'

const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API
const proxyAdmin = process.env.VUE_APP_ENV === 'local' ? '/proxy_admin' : process.env.VUE_APP_ADMIN

const jobs = {
	// 获取职位详情数据
	getJobInfo: token => {
		return api.get(proxyApi + `/v3/jobs/${ token }/related_info`)
	},
	// 热门职位的收藏和取消收藏和职位不感兴趣
	switchLike: payload => {
		return api.post(proxyApi + '/v3/jobs/favorite_jobs', payload)
	},
	// 职位投递
	jobDelivery: (token, payload) => {
		return api.post(proxyApi + `/v3/jobs/${ token }/delivery`, payload)
	},
	// 职位投递学历和字数的校验
	jobDeliveryVerify: (token, payload) => {
		return api.post(proxyApi + `/v3/jobs/${token}/delivery_check`, payload)
	},
	// 投递弹窗验证
	jobDeliveryTips: (job_token) => {
		return api.post(proxyApi + `/v3/jobs/${job_token}/delivery_pointers`)
	},
	// 获取校招职位列表页
	getCompRecruitList: payload => {
		return api.get(proxyApi + '/v3/comp_recruit_infos/index', payload)
	},
	// 获取校招职位详情
	getCompInfo: token => {
		return api.get(proxyApi + `/v3/comp_recruit_infos/${token}`)
	},
	// 校招职位收藏和取消收藏职位
	changeLikeState: payload => {
		return api.post(proxyApi + '/v3/comp_recruit_infos/like', payload)
	},

	// 获取收藏职位列表
	getFavoriteList: payload => {
		return api.get(proxyApi + '/v3/jobs/favorite_jobs', payload)
	},
	// 获取已投职位列表
	getApplicationList: payload => {
		return api.get(proxyApi + '/v3/jobs/application_jobs', payload)
	},
	// 获取关注公司列表
	getFollowList: payload => {
		return api.get(proxyApi + '/v4/favorite_companies', payload)
	},
	// 获取网申状态
	getNetApplication: payload => {
		return api.get(proxyApi + '/v3/jobs/net_application_status', payload)
	},
	// 修改网申状态
	changeNetApplication: payload => {
		return api.put(proxyApi + '/v3/jobs/net_application_status', payload)
	},
	//banner图
	getBannerImg: payload => {
		return api.get(proxyApi + `/v3/banners`,payload)
	},
	// 获取内推详情
	getRecommendationDetail: token => {
		return api.get(proxyApi + `/v3/internal_recommends/${token}`)
	},
	// 获取测试报告
	getBriefReport: payload => {
		return api.get(proxyApi + `/v3/jobscan_reports/brief_report`,payload)
	},
	// 创建测试报告
	createReport: payload => {
		return api.post(proxyApi + `/v3/jobscan_reports`,payload)
	},
	// 职位聚合页详情
	getSpringOffer: (channel, payload) => {
		return api.post(proxyApi + `/v3/spring_recruits/${channel}`, payload)
	},
	// 微信模板消息职位聚合页相关推送
	// 聚合页A1,A2
	getRecommenderJobsByIntention: (payload) => {
		return api.get(proxyApi + `/v3/recommender/jobs/intention`, payload)
	},
	// 聚合页A3
	getRecommenderJobsByJob: payload => {
		return api.get(proxyApi + `/v3/recommender/jobs/job`, payload)
	},
	// 聚合页B
	getRecommenderJobs: payload => {
		return api.get(proxyApi + `/v3/recommender/jobs`, payload)
	},
	/**
	 * 根据html渲染图片
	 */
	renderImage: (html,token) => {
		return api.post(proxyApi + '/v3/medals/share',{html,token});
	},
	// 批量关注公司（ onboarding 流程）
	batchFollowCompany: payload => {
		return api.post(proxyApi + `/v3/favorite_companies_batch`,payload)
	},
	// 获取随机公司数据（ onboarding 流程）
	getRandomCompanyList: payload => {
		return api.get(proxyApi + `/v3/career_path_issues/random_companies`, payload)
	},
	joinTeam: (captain_token) => {
		return api.put(proxyApi + '/v3/jobs/member_fission',{captain_token});
	},
	getTeamInfo: () => {
		return api.get(proxyApi + '/v3/jobs/member_fission',{});

	}
}
export default jobs
